"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilledWarning = function FilledWarning() {
	return _react2.default.createElement(
		"g",
		{ id: "FilledWarning" },
		_react2.default.createElement("path", { d: "M494.4,384.6L289.6,24.4c-2.4-7.1-9.4-14.1-16.5-18.8c-21.2-11.8-51.8-4.7-63.6,18.8L7.1,384.6C2.4,391.7,0,401.1,0,408.2 c0,25.9,21.2,47.1,47.1,47.1H452c9.4,0,16.5-2.4,23.5-7.1C499.1,436.4,506.2,408.2,494.4,384.6z M277.8,161l-7.1,134.2h-33 L230.7,161H277.8z M254.3,368.2c-14.1,0-25.9-11.8-25.9-25.9c0-14.1,11.8-25.9,25.9-25.9s25.9,11.8,25.9,25.9 C280.2,356.4,268.4,368.2,254.3,368.2z" })
	);
};

exports.default = FilledWarning;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/FilledWarning.js
// module id = 2953
// module chunks = 4